@if (isAWS) {
  <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-150 fs-16">
    <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
    <div class="mt-10 feature-not-avaliable">
      {{ 'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco }}
    </div>
  </div>
} @else if (
  (((data.deploymentClass === DeploymentClass.D || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_NONPII]) ||
  ((data.deploymentClass === DeploymentClass.B || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_PII]) ||
  ((data.deploymentClass === DeploymentClass.A || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_LIVE]))
) {

  @if (data?.cob && data?.cob?.status !== DeployStatus.DELETED) {
    
    <div [ngClass]="{ 'disabled': showLoader }">
      <div>
        <h3 class="mt-0 fs-18">{{ 'TENANT_DETAILS.COB_DETAILS' | transloco }}</h3>

        @if (data?.cob?.status === 'failed' || data?.cob?.status === 'inprogress') {
          <div class="mt-12 mb-16 pt-8 pb-8 pl-12 fw-500 flex items-center"
            [ngClass]="{
              'cob-inprogress': data?.cob?.status === 'inprogress',
              'cob-failed': data?.cob?.status === 'failed'
            }">
            @if (data?.cob?.status === 'failed') {
              <mat-icon svgIcon="report_problem" class="icon-md mr-8"></mat-icon>
            }
            @if (data?.cob?.status === 'inprogress') {
              <mat-spinner class="mr-8" diameter="20" color="primary" mode="indeterminate"></mat-spinner>
            }
            {{ data?.cob?.status === 'failed' ? ('INSTANCE_DETAILS.COB_CONFIG_FAILED' | transloco)
            : ('INSTANCE_DETAILS.COB_CONFIG_INPROGRESS' | transloco) }}
          </div>
        }
      </div>

      <div class="settings-log pl-24">
        <div class="flex flex-row justify-between">
          <div class="label-text flex fw-600 fs-16">
            <div class="cob-key-ado">{{ 'INSTANCE_DETAILS.ADO_PIPELINE_URL' | transloco }}</div>
            <div>:</div>
            @if (data?.cob?.adoPipelineUrl) {
              <a href="javascript:void(0);" (click)="openCobPipelineUrl(data?.cob?.adoPipelineUrl)" class="no-underline-cob">
                {{ 'GROUPS.CLICK_HERE' | transloco }}
              </a>
            } @else {
              <div class="ml-6">--</div>
            }
          </div>

          <div class="flex gap-6">
            @if (data?.cob?.status === DeployStatus.CONFIGURED) {
              <button (click)="viewCobDetails()" class="flex justify-center items-center h-32 cob-button" color="view">
                <div class="flex flex-row justify-start items-center">
                <mat-icon svgIcon="remove_red_eye" class="icon-md mr-10"></mat-icon>
                <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{ 'BUTTONS.VIEW' | transloco }}</div>
                </div>
              </button>

              <button (click)="onEditClick(data?.cob?.inputs, 'update')"
                class="flex justify-center items-center h-32 primary-bg"
                [ngClass]="{ 'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES }"
                [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES">
                <div class="flex flex-row justify-start items-center white-fg">
                <mat-icon svgIcon="edit" class="icon-md mr-10"></mat-icon>
                <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{ 'BUTTONS.EDIT' | transloco }}</div>
                </div>
              </button>
            }

            @if (
              data?.cob?.status === DeployStatus.FAILED ||
              data?.cob?.status === DeployStatus.CONFIGURED ||
              data?.cob?.status === DeployStatus.DELETION_FAILED
            ) {
              <button (click)="deleteCobDetails()"
                class="flex justify-center items-center h-32 cob-button"
                color="red"
                [ngClass]="{ 'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES }"
                [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES">
                <div class="flex flex-row justify-start items-center white-fg">
                <mat-icon svgIcon="delete" class="icon-md mr-10"></mat-icon>
                <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{ 'BUTTONS.DELETE' | transloco }}</div>
                </div>
              </button>
            }

            @if (data?.cob?.status === DeployStatus.DELETING) {
              <div class="flex flex-row">
                <mat-spinner diameter="20" class="mr-12" color="primary" mode="indeterminate"></mat-spinner>
                {{ 'INSTANCE_DETAILS.COB_DELETING_MSG' | transloco }}
              </div>
            }

            @if (data?.cob?.status === DeployStatus.FAILED) {
              <button (click)="onEditClick(data?.cob?.inputs, 'reconfigure')"
                class="flex justify-center items-center tenant-gradient h-32 cob-button"
                [ngClass]="{ 'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES }"
                [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES">
                <div class="flex flex-row justify-start items-center primary-fg">
                <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{ 'SOLUTIONS.RECONFIGURE' | transloco }}</div>
                </div>
              </button>
            }
          </div>
        </div>

        <div class="flex flex-row">
          <div class="label-text flex mt-24 fw-500 fs-16 vertical-indicator-cob">
            <div class="cob-key">{{ 'TEST_RESULTS.SCHEDULE1' | transloco }}</div>
            <div>:</div>
                @if (data) {
                  <div class="fw-500 fs-16 schedule-color pl-4">
                      {{ sch1 ? sch1 : '--' }}
                  </div>
                } @else {
                  <ng-template #loader></ng-template>
                }
          </div>
          <div class="label-text flex mt-24 fw-500 fs-16">
            <div class="cob-key">{{ 'TEST_RESULTS.SCHEDULE2' | transloco }}</div>
            <div>:</div>
                @if (data) {
                  <div class="fw-500 fs-16 schedule-color pl-4">
                      {{ sch2 ? sch2 : '--' }}
                  </div>
                } @else {
                  <ng-template #loader></ng-template>
                }
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="{ 'disabled': showLoader }">
      <app-environment-paginator [length]="cobTable?.length" [pageIndex]="pageIndex" [pageSize]="cobPaginationSize" (page)="cobPageChanged($event)" class="flex justify-end env-paginator"></app-environment-paginator>
    </div>
    @if (showLoader) {
  <div class="p-12 flex justify-center items-center">
    <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
  </div>
}  
 @else if (cobTable?.length > 0) {
      <div class="flex flex-col mt-20 endpoints border-radius deploymentLogs" [ngClass]="{'disabled': showLoader}">
        <table mat-table [dataSource]="dataSourceCob" matSort (matSortChange)="sortCobData($event)" multiTemplateDataRows class="mat-elevation-z8">
                <ng-container matColumnDef="menu">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 expand-column"></th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}">
                    <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8 cursor-pointer expand-column"
                      [matMenuTriggerFor]="cobSubmenu">
                      <mat-icon [svgIcon]="!data.arrowClick ? 'chevron_right' : 'expand_more'" class="relative-class" (click)="onCobArrowClick(data); $event.stopPropagation()"></mat-icon>
                    </button>
                    <mat-menu #cobSubmenu [xPosition]="'before'" class="context-menu-dropdown">
                      @if (arrowClicked) {
                        <div class="flex flex-col"></div>
                        }
                    </mat-menu>
                  </td>
                </ng-container>
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.COB_BUILD_ID' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" class="route-id id-width cell-data fw-400 fs-16 edit_hover_class">
                    @if (data?.cobRunId) {
                        <a class="items-center fw-400 fs-14 ml-10 no-underline-cob" href="javascript:void(0)" [ngClass]="{ 'text-underline': adoPipelineUrl && adoProjectName }" (click)="adoPipelineUrl && adoProjectName ? onClickLink(data?.cobRunId) : ''"> {{ data?.cobRunId | titlecase }}</a>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.COB_DATE' | transloco | uppercase}}</th>
                  <td mat-cell *matCellDef="let data" class="route-id date-width cell-data fw-400 fs-16">{{data?.cobDate ? (data?.cobDate !== '--' ? (data?.cobDate | date: 'dd MMM yyyy') : data?.cobDate) : '-'}}</td>
                </ng-container>
                <ng-container matColumnDef="timeTaken">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.TOTAL_TIME_TAKEN' | transloco | uppercase }}</th>
                  <td mat-cell *matCellDef="let data" class="route-id time-width cell-data fw-400 fs-16">{{data?.totalTime | titlecase}}</td>
                </ng-container>
                <ng-container matColumnDef="completionMode">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 text-right"></th>
                  <td mat-cell *matCellDef="let data" class="text-right justify-center result cell-data fw-400 fs-16" [ngClass]="{'completion-width' : data?.completionMode !== 'manual'}">
                    @if (data?.completionMode === 'manual') {
                    <span class="flex items-center completion-mode fs-14 fw-400 pt-8 pr-16 pb-8 pl-16 mr-16">
                        {{ 'INSTANCE_DETAILS.MANUAL' | transloco }}
                    </span>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                  <td mat-cell *matCellDef="let data" class="status-width route-id cell-data fw-400 fs-16">
                    <div class="flex flex-row justify-center items-center service-version width-status pt-8 pr-16 pb-8 pl-16 mr-24" [ngClass]="data?.status === 'completed' ? 'success-cob' : data?.status === 'started' ? 'started' : data?.status === 'not started' ? 'not-started' : 'failed-cob'">
                      @if (data?.status !== 'not started') {
                        <mat-icon class="icon-md p-2 mr-4" [svgIcon]="data?.status === 'failed' ? 'error' : data?.status === 'completed' ? 'check_circle' : data?.status === 'started' ? 'change_circle' : ''"></mat-icon>
                        }
                      <span class="status-button">{{data?.status ? (data?.status | titlecase) : '-'}}</span>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="download">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 text-right"></th>
                  <td mat-cell *matCellDef="let data" class="text-right cursor-pointer download-width result cell-data fw-400 fs-16" (click)="downloadCobReport(data)">
                    @if (data?.reportFile) {
                     <span class="pl-20 flex items-center">
                        <mat-icon svgIcon="file_download" class="flex justify-end"></mat-icon>{{ 'INSTANCE_DETAILS.DOWNLOAD' | transloco }}
                     </span>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="cobMenu">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                  <td mat-cell *matCellDef="let data" class="expand">
                    @if (data?.status !== 'completed' && (!data?.completionMode || data?.completionMode !== 'manual')) {
                     <button class="flex w-100-percent justify-end items-center context-menu-icon cursor-pointer" [matMenuTriggerFor]="subMenu" (click)="menuItemClick()">
                        <mat-icon svgIcon="more_vert"></mat-icon>
                     </button>
                    }
                    <mat-menu #subMenu [xPosition]="'before'" class="context-menu-dropdown">
                      <div class="flex flex-col">
                        <button class="menu-button" (click)="menuClick(data)">
                          <div class="flex flex-row justify-start items-center">
                            <mat-icon svgIcon="check" class="icon-md"></mat-icon>
                            <div class="mat-body fw-400">{{'INSTANCE_DETAILS.MARK_AS_COMPLETED' | transloco }}</div>
                          </div>
                        </button>
                      </div>
                    </mat-menu>
                  </td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="cobColumns.length" [ngClass]="{'inner-table': element === expandedElement}" class="inner-table">
                    <div class="example-element-detail flex-col" *ngIf="element === expandedElement" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                      <ng-container *ngIf="dataSourceInnerCob?.length > 0; else noInnerLogFound">
                      <table mat-table [dataSource]="dataSourceInnerCob" multiTemplateDataRows class="mat-elevation logs">
                        <ng-container matColumnDef="stage">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.STAGE' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.stage ? data?.stage : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="startTime">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.START_TIME' | transloco | uppercase}}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.startTime ? (data?.startTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="endTime">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.END_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.endTime ? (data?.endTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="duration">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.DURATION' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.startTime | timeDuration : data?.endTime : '-'}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                          <td mat-cell *matCellDef="let data" class="status-width route-id cell-data fw-400 fs-16">
                            <div class="flex flex-row justify-center items-center service-version width-status pt-8 pr-16 pb-8 pl-16 mr-24" [ngClass]="data?.status === 'completed' || data?.status === 'started' ? 'success-cob' : data?.status === 'not started' ? 'not-started' : 'failed-cob'">
                              <mat-icon *ngIf="data?.status !== 'not started'" class="icon-md p-2 mr-4" [svgIcon]="data?.status === 'failed' ? 'error' : (data?.status === 'completed' || data?.status === 'started' ? 'check_circle' : '')"></mat-icon>
                              <span class="status-button">{{data?.status ? (data?.status | titlecase) : '-'}}</span>
                            </div>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="message">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                          <td mat-cell *matCellDef="let data" class="route-id msg-width cell-data fw-400 fs-16">
                            <span *ngIf="(data?.status === 'failed' || data?.status === DeployStatus.COB_NOT_STARTED || data?.status === 'completed') && data?.message" class="pl-20 flex items-center cursor-pointer" (click)="messageClick(data)">
                              <mat-icon class="icon-md p-2 mr-4" svgIcon="chat"></mat-icon>{{'INSTANCE_DETAILS.MSG' | transloco }}
                            </span>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerCobColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerCobColumns;"></tr>
                        </table>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="cobColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: cobColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
              </table>
      </div>
      @if (cobTable?.length) {
        <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
              <mat-spinner diameter="24"
                color="primary"
                mode="indeterminate">
              </mat-spinner>
        </mat-card>
      }
    }
  } @else {
    <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-150 fs-16">
    <div class="flex justify-center pt-8 pb-8 fw-400">
      {{ 'INSTANCE_LIST.NO_COB_MESSAGE' | transloco }}
    </div>
    <div class="flex justify-center pt-12">
      <button class="flex rounded justify-center items-center tenant-gradient mat-subtitle-2"
        [ngClass]="{ 'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || !isCobLoaded) : !isCobLoaded }"
        mat-button type="button"
        (click)="configureCob()">
        {{ 'INSTANCE_DETAILS.CONFIGURE_COB' | transloco }}
      </button>
    </div>
    </div>
  }
} @else {
  <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
    <img src="/assets/images/feature_not_available.png">
    <div class="mt-10 feature-not-avaliable">
      {{ 'FEATURE.FEATURE_NOT_AVAILABLE' | transloco }}
    </div>
  </div>
}
